<template>
<div class="change-insurance-dialog">
  <common-dialog :show.sync="visible" title="修改保期" :show-footer="false">
    <div class="change-insurance-body" v-if="visible">
      <div class="product-info-box">
        <div class="product-info" @click="goDetail('detail')" >
          <img class="product-img" src="https://o.666visa.cn/static/ssqpeer/order/insurance-img.png" />
          <div class="product-info-right">
            <div class="product-name">{{order.product_insurance.insurance_name}}</div>
            <div class="product-info-bottom">
              <div class="claim-price">最高可理赔{{order.product_insurance.max_claim / 100 / 10000}}万</div>
              <div class="detail-btn">查看详情</div>
            </div>
          </div>
        </div>
        <div class="product-options">
          <div class="options-item" v-for="(item, index) in order.product_insurance.fee_desc" :key="index">
            <div class="item-label">{{item.key}}</div>
            <div class="item-value">
              <div class="price">￥{{item.fee / 100}}</div>
              <div class="person">/人</div>
              <div class="item-step" v-if="item.step">/{{stepMap[item.step]}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="insurance-form">
        <div class="form-item applicant">
          <div class="item-label">被保人员</div>
          <div class="item-content">
            {{name}}
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">起保日期</div>
          <div class="item-content">
            <insurance-date-picker
              :select-date="formData.start_date"
              @input="changeStartDate"
              :min-disabled-date="new Date()"
            ></insurance-date-picker>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">保障天数</div>
          <div class="item-content">
            <div class="protect-days-box">
              <div class="insurance-day">
                <el-select v-model="formData.insurance_day_index" placeholder="请选择" @change="changeInsuranceDay">
                  <el-option v-for="(item, index) in order.product_insurance.fee_desc" :key="index"
                    :label="item.key" :value="index"></el-option>
                </el-select>
              </div>
              <div class="over-day" v-if="order.product_insurance.fee_desc[formData.insurance_day_index].step">
                <el-select v-model="formData.over_day_index" placeholder="请选择" @change="getInsurancePrice">
                  <el-option v-for="(item, index) in over_day_array" :key="index"
                    :label="item.label" :value="index"></el-option>
                </el-select>
              </div>
            </div>
            <div class="end-day" v-if="end_date">终止日期：<span>{{end_date | date('YYYY年MM月DD日')}} {{end_date | week}}</span></div>
          </div>
        </div>

      </div>

      <div class="tips-box">
        <div >1. 旅游保险将为旅行过程提供保障，生效日期和终止日期尽可能覆盖完整行程；</div>
        <div >2. 若修改后的保障天数所需费用比原保障天数更低，差价部分将不予退还，尽请谅解。</div>
      </div>
      <div class="footer">
        <div class="price-box">
          <div class="price-label">补缴费用</div>
          <div class="price-value">
            <span class="unit">￥</span>{{(formData.insurance_fee * formData.insurance_discount) | price}}
            <div class="discount" v-if="formData.insurance_fee && formData.insurance_discount < 1">{{formData.insurance_discount * 10}}<span>折</span></div>
          </div>
        </div>
        <div class="submit-btn">
          <button @click="submit" class="s-btn btn-orange" :disabled="!is_change_form_data">立即支付</button>
        </div>
      </div>
    </div>
  </common-dialog>
  <!-- 充值弹窗 -->
  <recharge-dialog v-model="showRechargeDialog" @recharge-success="getPeerInfo" from="changeInsurance">
  </recharge-dialog>
</div>

</template>
<script>
import moment from 'moment';
import commonDialog from '../common/modals/common-dialog/common-dialog';
import Http from '../../libs/http.js';
import rechargeDialog from '../common/recharge-dialog';
import insuranceDatePicker from '../insurance-date-picker';

export default {
  name: '',
  components: {
    commonDialog,
    rechargeDialog,
    insuranceDatePicker,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
    },
  },
  data() {
    return {
      stepMap: { 1: '天', 7: '周' },
      peer: { balance_amount: 0 },
      visible: this.value,
      applicantList: [], // 当前可以修改保险的申请人列表
      originalForm: { // 初始数据
        start_date: '',
        insurance_day_index: 0,
        over_day_index: 0,
      },
      formData: {
        start_date: '',
        insurance_day_index: 0,
        over_day_index: 0,
        insurance_fee: 0,
        insurance_discount: 1,
      },
      showRechargeDialog: false,
    };
  },
  computed: {
    pickerOptions() {
      return { // 日期选择控件配置
        disabledDate(time) {
          return time.getTime() < (Date.now());
        },
      };
    },
    // 用户自选保险 每增加一天加收保费 选项
    over_day_array() {
      if (!(this.order && this.order.product_insurance)) return [];
      // 构造每增加一天就加收保费的天数数组
      const product_insurance = this.order.product_insurance;
      const over_default_day = product_insurance.fee_desc.filter(item => item.step).pop();
      if (!over_default_day) return [];
      const over_day_array = [];
      if (product_insurance.fee_desc.some(item => item.step)) {
        for (let index = over_default_day.min; (index + over_default_day.step - 1) <= over_default_day.max; index += over_default_day.step) {
          over_day_array.push({
            label: `${index + over_default_day.step - 1}天`,
            value: index + over_default_day.step - 1,
          });
        }
      }
      return over_day_array;
    },
    protect_days() {
      if (!this.order) return 0;
      let protect_days = 0;
      const { formData, order, over_day_array } = this;
      const { insurance_day_index, over_day_index } = formData;
      const insurance_day_array = order.product_insurance.fee_desc;
      if (insurance_day_array[insurance_day_index].step) {
        protect_days = over_day_array[over_day_index].value;
      } else {
        protect_days = insurance_day_array[insurance_day_index].max;
      }
      return protect_days;
    },
    end_date() {
      if (!this.order) return '';
      const { protect_days, formData } = this;
      const { start_date } = formData;
      if (!start_date || !protect_days) return '';
      const end_date = new Date(start_date);
      end_date.setDate(end_date.getDate() + protect_days - 1);
      return moment(end_date).format('YYYY-MM-DD');
    },
    is_change_form_data() {
      if (!this.order) return '';
      return this.originalForm.start_date !== this.formData.start_date ||
        this.originalForm.insurance_day_index !== this.formData.insurance_day_index ||
        this.originalForm.over_day_index !== this.formData.over_day_index;
    },
    name() {
      const nameArr = this.applicantList.map(item => item.applicant_name);
      let name = '';
      if (nameArr.length < 4) {
        name = nameArr.join('、');
      } else {
        name = `${nameArr.slice(0, 3).join('、')}等${nameArr.length}人`;
      }
      return name;
    },
  },
  watch: {
    visible(newValue) {
      this.$emit('input', newValue);
    },
    value(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
  },
  created() {
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      this.applicantList = this.order.applicant.filter(item => item.applicant_insurance && item.applicant_insurance.status === 1);
      this.initInsuranceForm();
      this.getPeerInfo();
    },
    initInsuranceForm() {
      let start_date = this.order.depart_date;
      let insurance_day_index = 0;
      let over_day_index = 0;
      if (this.order.order_insurance) {
        start_date = this.order.order_insurance.start_date;
        const protect_days = this.order.order_insurance.protect_days;
        this.order.product_insurance.fee_desc.forEach((item, index) => {
          if (+protect_days >= item.min && +protect_days <= item.max) {
            insurance_day_index = index;
          }
        });
        this.over_day_array.forEach((item, index) => {
          if (item.value === +protect_days) {
            over_day_index = index;
          }
        });
      }
      this.formData.start_date = start_date;
      this.formData.insurance_day_index = insurance_day_index;
      this.formData.over_day_index = over_day_index;
      this.formData.insurance_fee = 0;
      this.formData.insurance_discount = 1;

      this.originalForm.start_date = start_date;
      this.originalForm.insurance_day_index = insurance_day_index;
      this.originalForm.over_day_index = over_day_index;
    },
    getPeerInfo() {
      Http.post('/visa_peer_query').then((data) => {
        this.peer = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    changeStartDate(date) {
      this.formData.start_date = moment(date).format('YYYY-MM-DD');
      this.getInsurancePrice();
    },
    // 更改了保障天数，清空超出的天数
    changeInsuranceDay() {
      this.formData.over_day_index = 0;
      this.getInsurancePrice();
    },
    goDetail(type) {
      const routeUrl = this.$router.resolve({
        name: 'BusinessView',
        query: {
          caseCode: this.order.product_insurance.case_code,
          visa_product_id: this.order.visa_product_id,
          user_order_id: this.order.user_order_id,
          type,
        },
      });

      window.open(routeUrl.href, '_blank');
    },
    submit() {
      const {
        formData,
      } = this;
      if (this.loading) return;
      this.loading = true;
      this.getInsurancePrice().then(() => {
        this.$confirm('确定要修改保障日期？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '再想想',
        }).then(() => {
          // 余额
          const balance_amount = this.peer.balance_amount;
          const pay_fee = formData.insurance_fee * formData.insurance_discount;
          // 余额不足
          if (pay_fee > balance_amount) {
            this.$confirm('账户余额不足，请充值后再进行支付', '提示', {
              confirmButtonText: '立即充值',
              cancelButtonText: '取消',
            }).then(() => {
              // 充值成功以后，会回调到callbackCharge这个函数
              this.showRechargeDialog = true;
            });
            this.loading = false;
            return;
          }
          if (pay_fee !== 0) {
            this.$confirm('该订单将使用余额支付？', '订单支付', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
            }).then(() => {
              this.realSubmit();
            }).catch(() => {
              this.loading = false;
            });
          } else {
            this.realSubmit();
          }
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    realSubmit() {
      this.getInsurancePrice().then(res => Http.post('/insurance_date_change', {
        order_id: this.order.user_order_id,
        change_id: res.change_id,
      })).then(() => {
        this.$message({
          message: '修改保期申请已提交',
          type: 'success',
        });
        this.loading = false;
        this.visible = false;
        this.$emit('on-success');
      }).catch(() => {
        this.loading = false;
      });
    },
    getInsurancePrice() {
      return Http.post('/insurance_try', {
        order_id: this.order.user_order_id,
        case_code: this.order.product_insurance.case_code,
        start_date: moment(this.formData.start_date).format('YYYY-MM-DD'),
        protect_days: this.protect_days,
      }).then((res) => {
        this.formData.insurance_fee = res.pay_amount;
        this.formData.insurance_discount = res.discount || 1;
        return res;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.change-insurance-dialog{
  /deep/ .el-dialog{
    width: 580px;
  }
}
.change-insurance-body{
  padding: 16px 24px 20px 24px;
  line-height: 1;
  .product-info-box{
    background: #FAFBFC;
    padding: 16px 20px;
    margin-bottom: 24px;
    border-radius:2px;
    .product-info{
      display: flex;
      align-items: center;
      position: relative;
      z-index: 1;
      border-bottom: 1px dashed #DEE2E6;
      padding: 8px 0 26px 92px;
      cursor: pointer;
      .product-img{
        position: absolute;
        left: -20px;
        top: 0;
        flex-shrink: 0;
        width: 100px;
        height: 106px;
        border-radius: 4px;
        margin-right: 24px;
      }
      .product-info-right{
        flex-grow: 1;
        overflow: hidden;
        .product-name{
          color: #2F333D;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 18px;
          position: relative;
          z-index: 1;
          &::after{
            content: "";
            position: absolute;
            z-index: -1;
            left: 0;
            bottom: -6px;
            background:linear-gradient(270deg,rgba(255,128,51,0) 0%,rgba(255,128,51,0.2) 100%);
            width:120px;
            height:12px;
          }
        }
        .product-info-bottom{
          display: flex;
          justify-content: space-between;
          .claim-price{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 24px;
            color: #fff;
            font-size: 14px;
            font-weight: 600;
            padding: 0 12px;
            background:linear-gradient(178deg,rgba(255,126,48,0.96) 0%,rgba(255,122,42,1) 100%);
            border-radius: 1px;
          }
          .detail-btn{
            font-size: 12px;
            color: #5F666E;
            display: flex;
            align-items: center;
            position: relative;
            &::after{
              content: "";
              flex-shrink: 0;
              margin-left: 4px;
              width: 12px;
              height: 12px;
              background: url(https://o.666visa.cn/static/ssqwxa/order-confirm/icon-right.png) no-repeat center / 100% 100%;
            }
          }
        }
      }
    }
    .product-options{
      padding-top: 16px;
      .options-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        &:last-child{
          margin-bottom: 0;
        }
        .item-label{
          color: #2F333D;
          font-size: 14px;
        }
        .item-value{
          display: flex;
          align-items: center;
          color: #5F666E;
          font-size: 14px;
          .price{
            color: #FF6800;
          }
          .person{
            margin-left: 4px;
          }
          .item-step{
            margin-left: 4px;
          }
        }
      }
    }
  }
  .insurance-form{
    .form-item{
      display: flex;
      align-items: flex-start;
      margin-bottom: 24px;
      &:last-child{
        margin-bottom: 0;
      }
      &.applicant{
        line-height: 24px;
        .item-label{
          line-height: 24px;
        }
      }
      .item-label{
        flex-shrink: 0;
        width: 72px;
        margin-right: 18px;
        font-size: 16px;
        line-height: 40px;
        color: #91999F;
      }
      .item-content{
        flex-grow: 1;
        color: #2F333D;
        font-size: 16px;
        /deep/ .el-date-editor{
          width: 100%;
          .el-icon-date{
            right: 12px;
          }
          .el-input__inner{
            height: 40px;
            border-radius: 2px;
            padding-right: 24px;
          }
        }
        .protect-days-box{
          border: 1px solid #DEE2E6;
          border-radius: 2px;
          /deep/ .el-select{
            height: 38px;
            width: 100%;
            .el-input{
              .el-input__icon{
                width: 24px;
                transform: translateY(-50%) rotateZ(180deg) scale(0.7);
                transform-origin: center center;
                right: 4px;
                color: #91999F;
                &.is-reverse{
                  transform: translateY(-50%) scale(0.7);
                }
              }
              .el-input__inner{
                border: none;
                height: 38px;
                border-radius: 2px;
                padding-right: 24px;
                color: #2F333D;
                font-size: 14px;
              }
            }
          }
          .over-day{
            /deep/ .el-select{
              .el-input{
                .el-input__inner{
                  border-top: 1px solid #DEE2E6;
                }
              }
            }
          }
        }
        .end-day{
          color: #91999F;
          font-size: 12px;
          margin-top: 8px;
        }
      }
    }
  }
  .tips-box{
    margin-top: 16px;
    background: #FAFBFC;
    border-radius: 2px;
    padding: 12px 20px;
    color: #91999F;
    font-size: 12px;
    line-height: 22px;
  }
  .footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .price-box{
      display: flex;
      align-items: center;
      .price-label{
        color: #2F333D;
        font-size: 16px;
        margin-right: 8px;
      }
      .price-value{
        color: #FF8033;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        position: relative;
        .unit{
          font-size: 14px;
        }
        .discount{
          position: absolute;
          left: 100%;
          top: -2px;
          margin-left: 4px;
          min-width: 46px;
          height: 28px;
          background: url(https://o.666visa.cn/static/ssqpeer/order/discount-bg.png) no-repeat center / 100% 100%;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          line-height: 1;
          display: flex;
          align-items: flex-start;
          padding-top: 3px;
          padding: 3px 8px 0 12px;
          span{
            opacity: 0.8;
            font-size: 12px;
            line-height: 18px;
            margin-left: 2px;
          }
        }
      }
    }
    .submit-btn{
      .s-btn{
        z-index: 1;
        width: 220px;
        height: 40px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/insurance/change-insurance-dialog.vue